import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import WelcomePage from './pages/WelcomePage';
import AdminPage from './pages/AdminPage';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig'; // add this at the top if it's missing


function App() {
  const { instance, accounts } = useMsal();
  console.log("MSAL accounts object:", accounts);
  console.log("Im looking that your email will contain the string 'admin' in order to access /admin page", accounts);
  const isAuthenticated = accounts.length > 0;
  const email = accounts.length > 0 ? accounts[0].username?.toLowerCase() : '';
  const hasCYEDomain = email.includes("admin");

  const login = () => {

    instance.loginRedirect(loginRequest);
  };

  const logout = () => {
    instance.logoutRedirect();
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<WelcomePage login={login} logout={logout} isAuthenticated={isAuthenticated} />} />
        <Route path="/admin" element={
          isAuthenticated && hasCYEDomain ? <AdminPage logout={logout} /> : <Navigate to="/" />
        } />
      </Routes>
    </Router>
  );
}

export default App;